<template>
  <el-dialog
      :title="$t('socialPosts.create.deletePlanifBrouillons.title')"
      :visible.sync="modalDeletePlanifBrouillons"
      v-loading="loadingStatus"
      width="45%"
      @close="closeModal">
        <span class="text-left">
          {{ $t('socialPosts.create.deletePlanifBrouillons.message')}}
        </span>
    <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="confirm()">{{ $t('socialPosts.create.deletePlanifBrouillons.confirm')}}</el-button>
          <el-button @click="closeModal()">{{ $t('socialPosts.create.deletePlanifBrouillons.cancel')}}</el-button>
        </span>
  </el-dialog>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'DialogDeletePlanifBrouillon',
  computed: {
    ...mapState('socialPostsCreationPostEditorial', [
      'modalDeletePlanifBrouillons',
      'loadingStatus'])
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial',
      ['SET_MODAL_DELETE_PLANIF_BROUILLONS']),
    ...mapActions('socialPostsCreationPostEditorial',
      ['validatePost']),
    confirm () {
      this.validatePost({ typePost: 'B' })
    },
    closeModal () {
      this.SET_MODAL_DELETE_PLANIF_BROUILLONS(false)
    }
  }
}
</script>

<style>

</style>
